import { memo, useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Badge from "@mui/material/Badge";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { when } from "util/support";
import type { ReviewableInputProps } from "./types";
import { ActionProvider, CommentContext, CommentProvider } from "./providers";
import { ActionList, ApproveDialog, CommentBoxPopover, RejectDialog } from "./components";

const Reviewable = ({
    sx,
    slots,
    slotProps,
    children,
    subject,
    onApprove,
    onReject,
    renderLabel = () => subject,
    ...restProps
}: ReviewableInputProps) => {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    return (
        <CommentProvider
            {...restProps}
            subject={subject}
        >
            <ActionProvider>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        ...sx
                    }}
                >
                    {slots?.input ?? children}
                    <CommentContext.Consumer>
                        {({ comments }) => (
                            <Tooltip
                                arrow
                                placement='right'
                                title={(
                                    when(
                                        Boolean(slotProps?.iconButton?.disabled),
                                        null,
                                        () => (
                                            <ActionList>
                                                {slots?.actions}
                                            </ActionList>
                                        )
                                    )
                                )}
                            >
                                <Badge
                                    variant='dot'
                                    color='secondary'
                                    invisible={!comments.length}
                                >
                                    <IconButton
                                        {...slotProps?.iconButton}
                                        ref={setAnchorEl}
                                    >
                                        <MoreVertIcon />
                                    </IconButton>
                                </Badge>
                            </Tooltip>
                        )}
                    </CommentContext.Consumer>
                    <CommentBoxPopover
                        anchorEl={anchorEl}
                    />
                </Box>
                <ApproveDialog
                    renderLabel={renderLabel}
                    onConfirm={onApprove}
                />
                <RejectDialog
                    renderLabel={renderLabel}
                    onConfirm={onReject}
                />
            </ActionProvider>
        </CommentProvider>
    );
};

export default memo(Reviewable);
